import React from 'react'

function Wrongurllookup() {
    return <div style={{display:'flex', width:'100%', height:'100vh', alignItems:'center', placeContent:'center', fontWeight:'bold', color:'#707070'}}>
        URL does not exist.
    </div>
}

export default Wrongurllookup